import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=729cbe3b&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729cbe3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('729cbe3b')) {
      api.createRecord('729cbe3b', component.options)
    } else {
      api.reload('729cbe3b', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=729cbe3b&scoped=true&", function () {
      api.rerender('729cbe3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20nwwJrD5W0lr/JS/comp/Accordion.vue"
export default component.exports